import {useAuth} from "../../providers/AuthProvider";
import {Modal} from "antd";
import React from "react";
import {useSearchParams} from "react-router-dom";

const ReadyToSubmitProfileModal = ({ onSubmitProfileApproval }) => {

    const {auth, submitProfileForApproval, isUpdating} = useAuth();

    const [searchParams, setSearchParams] = useSearchParams();

    const onClose = () => {
        if (isUpdating) {
            return;
        }
        let params = new URLSearchParams(searchParams);
        params.delete('submitForApproval');
        setSearchParams(params);
    }
    const onSubmit = async () => {
        const response = await submitProfileForApproval();

        if (response) {
            onClose();
            await onSubmitProfileApproval(response)
            TB.toast('Profile Submitted Successfully');
        }
    }

    return (
        <Modal
            open={searchParams?.has('submitForApproval')}
            onCancel={onClose}
            title={null}
            footer={null}
            closable={false}
            maskClosable={!isUpdating}
            destroyOnClose={true}
            width={550}
            className="[&_.ant-modal-content]:rounded-lg [&_.ant-modal-body]:p-0"
        >
            {/* Hero */}
            <div
                className="rounded-t-lg px-6 py-7 text-center"
                style={{ background: `linear-gradient(135deg, ${TB.config('color.secondary')} 0%, ${TB.config('color.secondary-darkest')} 100%)` }}
            >
                <div
                    className="w-16 h-16 rounded-full flex items-center justify-center text-2xl font-bold text-white mx-auto mb-3"
                    style={{ background: 'rgba(255,255,255,0.2)' }}
                >
                    ✓
                </div>
                <h4 className="text-xl font-bold mb-2 text-white">You're ready to submit!</h4>
                <p className="text-base opacity-90 text-white">One last step before clients can see you</p>
            </div>

            {/* Body */}
            <div className="px-6 py-5 flex flex-col items-stretch gap-7">
                {/* Checklist */}
                <div className="bg-gray-100 rounded-lg p-3.5 flex flex-col gap-3">
                    {[
                        'All required fields complete',
                        'Background, expertise & resume filled in',
                        'Work preferences set',
                    ].map(item => (
                        <div key={item} className="flex items-center gap-3 text-sm text-gray-700">
                            <span className="text-green-500 font-bold text-base leading-none">✓</span>
                            {item}
                        </div>
                    ))}
                </div>

                {/* Info block */}
                <div className="bg-purple-50 border-l-4 border-purple-600 rounded px-3 py-2.5 text-gray-800">
                    <strong className="block mb-2 text-base">What happens next?</strong>
                    <span className="text-sm">Wripple reviews your profile (typically within 1–2 business days). Once approved, clients can find and book you.</span>
                </div>

                {/* Actions */}
                <div className="flex gap-2">
                    <button
                        type="button"
                        disabled={isUpdating}
                        onClick={onSubmit}
                        className="flex-1 text-sm py-2.5 px-4 btn btn-primary"
                    >
                        {isUpdating ? 'Submitting...' : 'Submit for Approval →'}
                    </button>
                    <button
                        type="button"
                        disabled={isUpdating}
                        onClick={onClose}
                        className="text-sm py-2.5 px-4 btn btn-outline-dark"
                    >
                        Keep Editing
                    </button>
                </div>
            </div>
        </Modal>
    )
};


export default ReadyToSubmitProfileModal